var MemberOnly;

MemberOnly = window.MemberOnly != null ? window.MemberOnly : window.MemberOnly = {};

MemberOnly.init = function(arg, done) {
  var $tooltip, expectedSize;
  arg;
  expectedSize = $(".member-only").width();
  $tooltip = $("#member_only_tooltip");
  $tooltip.css("width", expectedSize);
  return done();
};

module.exports = MemberOnly;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9tZW1iZXJfb25seS9mcm9udGVuZC9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvbWVtYmVyX29ubHkvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxVQUFBLCtCQUFhLE1BQU0sQ0FBQyxhQUFQLE1BQU0sQ0FBQyxhQUFjOztBQUVsQyxVQUFVLENBQUMsSUFBWCxHQUFrQixTQUFDLEdBQUQsRUFBSyxJQUFMO0FBR2hCLE1BQUE7RUFIaUI7RUFHakIsWUFBQSxHQUFlLENBQUEsQ0FBRSxjQUFGLENBQWlCLENBQUMsS0FBbEIsQ0FBQTtFQUNmLFFBQUEsR0FBVyxDQUFBLENBQUUsc0JBQUY7RUFDWCxRQUFRLENBQUMsR0FBVCxDQUFhLE9BQWIsRUFBc0IsWUFBdEI7U0FFQSxJQUFBLENBQUE7QUFQZ0I7O0FBU2xCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
